import React, { useEffect, useState } from 'react';
import './customer-list.scss';
import AdminPage from '../../../components/common/page/AdminPage'
import TableFilter from '../../../components/common/table-filter/TableFilter'
import Spinner from '../../../components/common/spinners/SpinWithMessage'
import Modal from '../../../components/common/modal/Modal';
import CreateCustomer from '../../../components/admin/create-customer/CreateCustomer';
import InfoBox from '../../../components/common/info-box/InfoBox';
import NormalInput from '../../../components/common/inputs/NormalInput';
import SelectInput from '../../../components/common/inputs/SelectInput'
import CheckboxInput from '../../../components/common/inputs/CheckboxInput'
import { customerAxios, userAxios } from '../../../config/axios';
import { toast } from 'react-hot-toast'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaStar, FaEye } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { BiLoaderAlt } from 'react-icons/bi'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FcSearch, FcDeleteDatabase } from "react-icons/fc";
import { YYYYMMDDFormat } from '../../../assets/javascript/formate-functions';
import { thisMonthFirstDay, thisMonthLastDay } from '../../../assets/javascript/find-functions';

const CustomerList = () => {

    const [loading, setLoading] = useState('')
    const navigate = useNavigate()
    const [modal, setModal] = useState({ content: null, title: null, status: false })
    const [searchParams, setSearchParams] = useSearchParams()
    const [form, setForm] = useState({
        key: searchParams.get('key') || '',
        city_id: searchParams.get('city_id') || '',
        post: searchParams.get('post') || '',
        customer_status: searchParams.get('customer_status')?.split(' ') || [],
        flt_type: searchParams.get('flt_type') || '',
        flt_from: searchParams.get('flt_from') || YYYYMMDDFormat(thisMonthFirstDay(new Date())),
        flt_to: searchParams.get('flt_to') || YYYYMMDDFormat(thisMonthLastDay(new Date()))
    })
    const [data, setData] = useState([])
    const [ifSearch, setIfSearch] = useState(false)
    const [cities, setCities] = useState([])
    const [posts, setPosts] = useState([])

    const filtrationTypes = [
        { option: 'Installation', value: 'installed_at' },
        { option: 'Next periodical service', value: 'next_periodical_service_date' },
        { option: 'Package start', value: 'package_started_date' },
        { option: 'Package expiry', value: 'package_expiry_date' },
        { option: 'Tech last visited', value: 'technician_last_visited_date' },
    ]

    const openModal = (elem, title, data) => {
        setModal({
            content: elem,
            title,
            status: true
        })
    }

    const handleChange = (e) => {

        if (e.target.name === 'city_id' && !e.target.value) {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
                post: ''
            })
            setPosts([])
            return
        } else if (e.target.name === 'city_id') {
            const posts = cities?.filter((city) => city?.value === e.target.value)?.[0]?.post_offices || []
            setPosts(posts?.map((post) => ({ option: post, value: post })))
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleCustomerStatusChange = (e) => {
        const customer_status = form.customer_status.includes(e.target.value)
        if (customer_status) {
            setForm({
                ...form,
                customer_status: form.customer_status.filter((value) => e.target.value !== value)
            })
        } else {
            setForm({
                ...form,
                customer_status: [...form.customer_status, e.target.value]
            })
        }
    }

    const doFilter = () => {
        setLoading('filter')
        userAxios.get(`/customer/search?key=${form.key || ""}&post=${form?.post || ""}&city_id=${form?.city_id || ""}&customer_status=${form.customer_status || ""}&flt_type=${form.flt_type || ""}&flt_from=${form.flt_from || ""}&flt_to=${form.flt_to || ""}`)
            .then((response) => {
                setIfSearch(true)
                setData(response.data)
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const handleApply = (e) => {
        e.preventDefault();

        if (!form?.key && !form?.city_id && !form?.customer_status?.[0] && !form?.flt_type) {
            toast.error('Select any filter field')
            return;
        }

        if (form.key && form.key.length < 3) {
            toast.error('Enter at least 3 characters')
            return;
        }

        const newSearchParams = new URLSearchParams(searchParams);
        if (form.key) {
            newSearchParams.set('key', form.key);
        } else {
            newSearchParams.delete('key');
        }

        if (form.customer_status?.[0]) {
            newSearchParams.set('customer_status', form.customer_status.join(' '));
        } else {
            newSearchParams.delete('customer_status');
        }

        if (form.city_id) {
            newSearchParams.set('city_id', form.city_id);
        } else {
            newSearchParams.delete('city_id');
        }

        if (form.post) {
            newSearchParams.set('post', form.post);
        } else {
            newSearchParams.delete('post');
        }

        if (form.flt_type) {
            newSearchParams.set('flt_type', form.flt_type);
            newSearchParams.set('flt_from', form.flt_from);
            newSearchParams.set('flt_to', form.flt_to);
        } else {
            newSearchParams.delete('flt_type');
            newSearchParams.delete('flt_from');
            newSearchParams.delete('flt_to');
        }
        setSearchParams(newSearchParams);
        doFilter()

    }

    useEffect(() => {
        customerAxios.get('/l/area').then((response) => {
            const cityData = response.data?.map((city) => ({ option: city?.city_name, value: city?.city_id, post_offices: city?.post_offices }))
            setCities(cityData || [])
            if (form?.city_id) {
                const posts = response.data?.filter((city) => city?.city_id === form?.city_id)?.[0]?.post_offices || []
                console.log(response.data)
                setPosts(posts?.map((post) => ({ option: post, value: post })))
            }
        }).catch((error) => {
            toast.error(error?.message)
        })

        if (form.key || form?.city_id || form.customer_status?.[0] || form.flt_type || (form.search && form.search.length < 3)) {
            doFilter()
        }
    }, [])

    return (
        <div className="customer-list-div">
            <Modal modal={modal} setModal={setModal} />
            <AdminPage titleArray={['Customer list']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <div className="create-customer">
                            <button className='add-button'
                                onClick={() => openModal(<CreateCustomer setCustomerList={setData} setModal={setModal} />,
                                    'CREATE CUSTOMER')}><AiOutlinePlus /> New Customer</button>
                        </div>
                        <form action="" onSubmit={handleApply} >
                            <div className="search-section">
                                <h5>Search</h5>
                                <InfoBox description={'Your can search CID, Name, Address, Place, Pin and Contacts '} />
                                <NormalInput label='Enter at least 3 characters' name='key' onChangeFun={handleChange} value={form.key} isRequired={false} />
                                <SelectInput label={'City'} name={'city_id'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={cities?.map((item) => ({ ...item, selected: item.value === searchParams.get('city_id') }))} />
                                {posts?.[0] && <SelectInput label={'Post Office'} name={'post'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={posts?.map((item) => ({ ...item, selected: item.value === searchParams.get('post') }))} />}
                            </div>

                            <div className="search-section">
                                <h5>Customer status</h5>
                                <CheckboxInput label={'SSP'} name={'customer_status'} checked={form?.customer_status?.includes('SSP')} value={'SSP'} isRequired={false} onChangeFun={handleCustomerStatusChange} />
                                <CheckboxInput label={'I/W'} name={'customer_status'} checked={form?.customer_status?.includes('I/W')} value={'I/W'} isRequired={false} onChangeFun={handleCustomerStatusChange} />
                                <CheckboxInput label={'O/W'} name={'customer_status'} checked={form?.customer_status?.includes('O/W')} value={'O/W'} isRequired={false} onChangeFun={handleCustomerStatusChange} />
                                <CheckboxInput label={'O/C'} name={'customer_status'} checked={form?.customer_status?.includes('O/C')} value={'O/C'} isRequired={false} onChangeFun={handleCustomerStatusChange} />
                            </div>

                            <div className="search-section">
                                <h5>More options</h5>
                                <SelectInput label={'Filtration types'} name={'flt_type'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={filtrationTypes} />
                                <NormalInput label={'From date'} name={'flt_from'} value={form?.flt_from || YYYYMMDDFormat(thisMonthFirstDay(new Date()))} type={'date'}
                                    isRequired={false} onChangeFun={handleChange} />
                                <NormalInput label={'To date'} name={'flt_to'} value={form?.flt_to || YYYYMMDDFormat(thisMonthLastDay(new Date()))} type={'date'}
                                    isRequired={false} onChangeFun={handleChange} />
                            </div>

                            <div className="button-div">
                                <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Apply"}</button>
                            </div>
                        </form>
                    </div>
                    <div className="result-div">
                        {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                            : <h4>Find Whole house Customers</h4>
                        }
                        <div className="items-div">
                            {data?.[0] ? <>
                                <TableFilter >
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>CID</th>
                                                <th>Full name</th>
                                                <th>Status</th>
                                                <th>City / Post</th>
                                                <th>Contacts</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((customer) => <tr>
                                                <td style={{ textAlign: 'center' }}>{customer.cid}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <span style={{ fontWeight: 700 }}>{customer?.full_name}
                                                        {customer?.star_rate && <small className={`text-badge green-text`}><FaStar /> {customer?.star_rate}</small>}</span>
                                                    <br></br>
                                                    {`${customer?.address?.address || customer?.address?.place}`}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <small className={`text-badge ${customer?.wh_customer_status}-text`}>{customer?.wh_customer_status}</small>
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {customer?.address?.city_name} City <br></br>
                                                    P.O {customer?.address?.post}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {`${customer?.contact1 || ''}`}
                                                    <br></br>
                                                    {`${customer?.contact2 || ''}`}
                                                </td>
                                                <td >
                                                    <div className='buttons-div' >
                                                        <button title='View work card' className='button-small-icon view'
                                                            onClick={() => navigate(`/admin/customer-list/${customer?.cid}/cards`)}>
                                                            <FaEye /></button>
                                                        <button title='View details' className='button-small-icon edit'
                                                            onClick={() => navigate(`/admin/customer-list/${customer?.cid}/view`)}>
                                                            <FiEdit2 /></button>

                                                    </div>
                                                </td>
                                                {/* For Search */}
                                                <td style={{ display: 'none' }}>
                                                    {customer?.wh_customer_status} {customer?.address?.address} {customer?.address?.place}
                                                    {customer?.address?.pin_code} {customer?.address?.district} {customer?.address?.land_mark}
                                                    {customer?.full_name}
                                                </td>
                                            </tr>)}

                                        </tbody>
                                    </table>




                                </TableFilter>
                            </>
                                : <>
                                    <Spinner height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search customer'}
                                        icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                                </>}
                        </div>
                    </div>
                </div>




            </AdminPage>
        </div>
    )
}

export default CustomerList